import axios from "axios";
import { keycloak } from "../../lib/keycloak/index";
import { AuthService } from "./service";
import { UserDTO, UserInfoDTO } from "../user/dto";


export class AuthServiceImpl implements AuthService {

    findMeUser(): Promise<UserDTO> {
        let url = "/api/user/find-me"
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findByUserId(request: string): Promise<UserInfoDTO> {
        let url: string = "/api/users/" + request
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
